export const VENDOR_OPTIONS = [
    "Amazon",
    "Anthropic",
    "British Council",
    "Cambridge Assessment English",
    "CDXP",
    "Certible",
    "Cisco",
    "CompTIA",
    "Contentful",
    "Databricks",
    "dbt",
    "DevOpsTeam",
    "Google",
    "Hashicorp",
    "IBM",
    "ICPMSB",
    "IELTS",
    "IREB",
    "ISACA",
    "iSAQB",
    "ISTQB",
    "itedas",
    "Microsoft",
    "OpenAI",
    "Oracle",
    "PMI",
    "Red Hat",
    "SAFe",
    "SAP",
    "Salesforce",
    "SCRUMstudy",
    "ServiceNow",
    "Sitecore",
    "Stripe",
    "Scrum Alliance",
    "Scrum.org",
    "The Linux Foundation",
    "TOEFL",
    "TMMi",
    "UXQB",
    "VMware",
];
const translationEN = {
    title: "Certifications",
    subtitle: "Please complete this section. It is required.",
    addCertification: "Add certification",
    vendor: "Vendor",
    vendorPlaceholder: "Select or type vendor",
    vendorRequired: "Vendor is required",
    monthYearPlaceholder: "MM/YYYY",
    name: "Certificate Name",
    dateOfIssue: "Date of Issue",
    expirationDate: "Expiration Date",
    publicLink: "Public Link",
    openLink: "Open link in new tab",
    termless: "Termless",
};
const translationRU = {
    title: "Сертификаты",
    subtitle: "Заполните этот раздел.",
    addCertification: "Добавить сертификат",
    vendor: "Вендор",
    vendorPlaceholder: "Выберите или введите вендора",
    vendorRequired: "Вендор обязателен для заполнения",
    monthYearPlaceholder: "ММ/ГГГГ",
    name: "Название сертификата",
    dateOfIssue: "Дата выдачи",
    expirationDate: "Дата окончания",
    publicLink: "Публичная ссылка",
    openLink: "Открыть ссылку в новой вкладке",
    termless: "Бессрочно",
};
export const fields = (language) => (language === "RU" ? translationRU : translationEN);
